<ngx-ui-loader loaderId="successLoader"></ngx-ui-loader>

<div class="success-wrapper">
  <div class="success-content">
    <h2>Thank You !</h2>

    <p class="success-text">
      The challenge has been created successfully.
    </p>

    <!-- Corporate profile message -->
    <p *ngIf="corporateProfileConfirmation">
      Your account has been created successfully.
      Please log in to access your dashboard and continue.
    </p>

    <!-- Login button -->
    <button
      class="profile-btn"
      *ngIf="corporateProfileConfirmation"
      routerLink="/auth/login"
    >
      Login to Your Account
    </button>

    <!-- Back to create challenge -->
    <button
      class="profile-btn"
      *ngIf="!corporateProfileConfirmation"
      routerLink="/search_challenges"
    >
      Create Another Challenge
    </button>

    <!-- Redirect message -->
    <p class="desc mt-4" *ngIf="redirectUrl">
      You will be redirected shortly to the
      {{ corporateProfileConfirmation ? 'login page' : 'challenge page' }}.
    </p>
  </div>
</div>
